<template>
  <v-data-table
    mobile-breakpoint="0"
    item-key="id"
    :options.sync="groupTableOptions"
    :items-per-page="10"
    :server-items-length="totalItems"
    :headers="headers"
    :footer-props="footerTable"
    :items="groups"
    sort-by="name"
    @input="$emit('update:selected', $event)"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="loading"
    disable-sort
  >
    <template v-slot:bottom="{ pagination }">
      <v-data-footer
        :pagination="pagination"
        :options.sync="groupTableOptions"
        :items-per-page-options="[5, 10, 15]"
        items-per-page-text="Số dòng mỗi trang"
        :page-text="pageText"
      />
    </template>
    <template v-slot:no-data>
      <div class="my-14 font-weight-bold">
        <div>Hiện tại chưa có nhóm đối tượng trong danh sách.</div>
        <div>Vui lòng thực hiện thao tác thêm nhóm đối tượng ở phía trên.</div>
      </div>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <router-link :to="'/salary-group/' + item.id" style="text-decoration: none">{{ item.title }} </router-link>
    </template>
    <template v-slot:[`item.category`]="{ item }">
      <span v-if="item.category == 'custom'">Bổ sung</span>
      <span v-if="item.category == 'default'">Mặc định</span>
    </template>
    <template v-slot:[`item.amount`]="{ item }">
      {{ item.amount }}
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-btn icon @click="showGroupDetail(item.id)">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const originHeaders = [
  { text: 'Nhóm đối tượng', value: 'title', width: '50%' },
  { text: 'Phân loại', value: 'category', width: '20%' },
  { text: 'Số lượng giáo viên', value: 'amount', width: '20%' },
  { text: 'Thao tác', value: 'action', align: 'center', width: '10%' },
]

export default {
  data() {
    return {
      headers: originHeaders,
      originHeaders: originHeaders,
      selected: [],
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' },
      ],
      groupTableOptions: {},
    }
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
    type: String,
  },

  computed: {
    ...mapState('salaryGroup', ['totalItems', 'groups', 'pageText', 'loading', 'salarySearchParams']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('salaryGroup', ['requestPageSettings', 'deleteGroup', 'clean']),
    showGroupDetail(id) {
      this.$router.push({ path: `salary-group/${id}` })
    },
  },
  watch: {
    groupTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
            type: this.type,
          })
        }
      },
      deep: true,
    },
  },
  created() {
    this.clean()
  },
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}
</style>
